// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empleavesummarywidget-inline-1 {
  background: #0ea5e9;
}

.empleavesummarywidget-inline-2 {
  color: #0ea5e9;
}

.empleavesummarywidget-inline-3 {
  font-size: 11px;
  color: #64748b;
  margin-top: 6px;
}

.empleavesummarywidget-dyn-1 {
  background: var(--empleavesummarywidget-1-background);
}

.empleavesummarywidget-dyn-2 {
  color: var(--empleavesummarywidget-2-color);
}

.empleavesummarywidget-dyn-3 {
  width: var(--empleavesummarywidget-3-width);
  background: var(--empleavesummarywidget-3-background);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpLeaveSummaryWidget.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,qDAAqD;AACvD","sourcesContent":[".empleavesummarywidget-inline-1 {\n  background: #0ea5e9;\n}\n\n.empleavesummarywidget-inline-2 {\n  color: #0ea5e9;\n}\n\n.empleavesummarywidget-inline-3 {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 6px;\n}\n\n.empleavesummarywidget-dyn-1 {\n  background: var(--empleavesummarywidget-1-background);\n}\n\n.empleavesummarywidget-dyn-2 {\n  color: var(--empleavesummarywidget-2-color);\n}\n\n.empleavesummarywidget-dyn-3 {\n  width: var(--empleavesummarywidget-3-width);\n  background: var(--empleavesummarywidget-3-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
